import React from 'react';
import PropTypes from 'prop-types';
import Button from 'web_component_library/button';
import A11yContent from 'web_component_library/A11yContent';
import freedomTheme from 'web_component_library/theme/freedom';

const { colors } = freedomTheme;

const defaultOnClick = () => {};
const defaultText = '';
const defaultClassName = '';

const ChevronIcon = ({ isPrev = false }) => (
  <svg
    style={{ width: 'inherit', height: 'inherit' }}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {isPrev ? (
      <path
        d="M28 17L20 25L28 33"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M22 33L30 25L22 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

ChevronIcon.propTypes = {
  isPrev: PropTypes.bool,
};

export const Arrow = ({
  className = defaultClassName,
  onClick = defaultOnClick,
  isPrevArrow = false,
  text = defaultText,
  isEnabled = true,
}) => (
  <Button
    onClick={onClick}
    variant="none"
    disabled={!isEnabled}
    className={className}
    borderRadius="50%"
    sx={{
      background: 'white',
      width: '38px',
      height: '38px',
      boxShadow: '0 0 10px 4px rgba(0,0,0,0.2)',
      transition: 'all 150ms ease-in-out',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      color: colors.accessibleOrange,
      '&:hover:not(:disabled)': {
        background: '#F2F2F2',
        boxShadow: '0 0 10px 4px rgba(0,0,0,0.4)',
      },
      '&:disabled': {
        opacity: 0,
        visibility: 'hidden',
      },
    }}
  >
    <ChevronIcon isPrev={isPrevArrow} />
    <A11yContent as="span">{text}</A11yContent>
  </Button>
);

Arrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  isPrevArrow: PropTypes.bool,
  text: PropTypes.string,
  isEnabled: PropTypes.bool,
};
